export default "assets/images/logo-aff03e75.png";